// extracted by mini-css-extract-plugin
export default {"Content":"ScriptCreationAssistant_Content__3b7Fe","Description":"ScriptCreationAssistant_Description__bZMOu","PromptInput":"ScriptCreationAssistant_PromptInput__c4QQO"};